module.exports = __webpack_public_path__ + "static/media/d14ru.cc7a6567.pdf";